import isEmpty from 'lodash/isEmpty';
import { TEXTS } from 'shared/components/Footer/constants';

const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const validateEmail = (email: string) => {
  if (isEmpty(email)) {
    return {
      status: false,
      error: TEXTS.EMAIL_REQUIRED,
    };
  }

  if (emailRegex.test(email.toLowerCase()) === false) {
    return {
      status: false,
      error: TEXTS.EMAIL_INVALID,
    };
  }

  return { status: true };
};
